exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".on[data-v-007b3376]{border-color:#3b82f6;background-color:#3b82f6}.off[data-v-007b3376]{border-color:#90b1d5;background-color:#fff}.read_only.on[data-v-007b3376]{border-color:#4299e1;background-color:#4299e1}.read_only.off[data-v-007b3376]{border-color:#f5f5f5;background-color:#f5f5f5}.accordion .read_only.off[data-v-007b3376]{border-color:#fff;background-color:#fff}", ""]);

// exports
